/* eslint-disable arrow-body-style */
import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { prefix } from './constants';

export const getStoreStats: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/store/stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const downloadSteamMetrics: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/overview/steam_analysis_download`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getGameStoreFeedsStats: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/store/feeds/stats`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
